import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import HistorialPago from './PrintModal/HistorialPago';


const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class PrintModal extends React.Component {
    render() {


        return (
            <Modal
                title={"Detalle de Pagos de Comprobante"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>,
                    <Button
                      key="ok"
                      type="primary"
                     // onClick={() => this.props.onImprimir(this.props.formValues.idDocumentoElctronico)}  
                     onClick={this.props.onClose}

                    >
                      Aceptar
                    </Button>,
                    
                ]}
            >
                <Form>

                    
                <div className="row">
                        <div className="col-md-2">
                            <Form.Item label="Documento">
                            <Input readOnly
                                    value={this.props.formValues.DocumentoCliente}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Cliente">
                                <Input readOnly
                                    value={this.props.formValues.RazonSocialClientemento}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-2">
                            <Form.Item label="Fecha Comprobante">
                            <Input readOnly
                                    value={this.props.formValues.fechaStr}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-2">
                            <Form.Item label="Tipo Cambio">
                            <Input readOnly
                                    value={this.props.formValues.tipoCambio}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
              
                        <div className="col-md-3">
                            <Form.Item label="Nro Comprobante">
                                <InputGroup compact>
                                    <Input readOnly
                                        value={this.props.formValues.NumeroDocumento}
                                    />
                                   
                                </InputGroup>
                            </Form.Item>
                        </div>
                        
                        <div className="col-md-3">
                            <Form.Item label="Moneda Origenal">
                                <Input readOnly
                                    value={this.props.formValues.Moneda}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Cuota">
                                <Input readOnly
                                    value={this.props.formValues.cuota}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Importe Cuota">
                            <Input readOnly
                                    value={this.props.formValues.Monto}
                                />
                            </Form.Item>
                        </div>

                    </div>
        
             
                    <div className="row">
                    
                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Historial de Pagos" key="2">
                                    <HistorialPago
                                        dataSource={this.props.formValues.lst_historialPago}
                                    />
                                </TabPane>
                        </Tabs>  
                        </div>
                    </div>
               
                </Form>
            </Modal>
        );
    }
}